<template>
  <div id="app" class="page-shell">
    <header v-if="showHeader" class="app-header">
      <div class="app-header-inner">
        <router-link to="/" class="brand-link">
          <img
            src="@/assets/logo.svg"
            alt="Orator Pro"
            width="170"
          />
        </router-link>
        <button class="logout-button" type="button" @click="signOut">
          Sign out
        </button>
      </div>
    </header>
    <component :is="childComponent"></component>
  </div>
</template>

<script>
import { logout } from "@/lib/api";

export default {
  name: "MainParent",
  props: {
    childComponent: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showHeader() {
      return !this.$route.path.includes("/presenter");
    },
  },
  methods: {
    async signOut() {
      try {
        await logout();
      } finally {
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style>
body {
  margin: 0;
  background-color: var(--orator-light);
  font-family: var(--orator-font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  color: var(--orator-navy);
}

.page-shell {
  min-height: 100vh;
}

.app-header {
  background: white;
  border-bottom: 1px solid var(--orator-smoke);
  margin-bottom: 1.5rem;
}

.app-header-inner {
  max-width: 1380px;
  margin: 0 auto;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.brand-link {
  display: inline-flex;
  align-items: center;
}

.text-primary {
  color: var(--orator-navy);
}

.text-secondary {
  color: var(--orator-graphite);
}

.logout-button {
  border: 1px solid var(--orator-steel);
  background: white;
  border-radius: 0.375rem;
  padding: 0.45rem 0.8rem;
  font-weight: 800;
  color: var(--orator-arsenic);
}
</style>
